
/* ALL_NOTIFICATION_LIST */
export const GET_ALL_NOTIFICATION_LIST = "GET_ALL_NOTIFICATION_LIST"
export const GET_ALL_NOTIFICATION_LIST_SUCCESS = "GET_ALL_NOTIFICATION_LIST_SUCCESS"
export const GET_ALL_NOTIFICATION_LIST_FAIL = "GET_ALL_NOTIFICATION_LIST_FAIL"

